import React from "react";
import { EyeIcon } from "lucide-react";
export default function ReceiptTable({ receiptData }) {
  return (
    <div className="border rounded-lg shadow-md overflow-auto h-[500px]">
      <table className="min-w-full border-collapse bg-white">
        <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">Date</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">Receipt No</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">PO No</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">Qty</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">Staff</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">Vendor</th>
            <th className="p-3 border-b border-gray-200 text-center font-semibold">View</th>
          </tr>
        </thead>
        <tbody>
          {receiptData?.slice().sort((a, b) => b.receipt_no - a.receipt_no) .map((row, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="p-3 border-b border-gray-100 text-center">
                {new Date(row.date).toLocaleDateString("en-GB")}
              </td>
              <td className="p-3 border-b border-gray-100 text-center">{row.receipt_no}</td>
              <td className="p-3 border-b border-gray-100 text-center">
                {Array.isArray(row.po_number) ? row.po_number.join(", ") : ""}
              </td>
              <td className="p-3 border-b border-gray-100 text-center">{row.receipt_item_qty}</td>
              <td className="p-3 border-b border-gray-100 text-center">{row.staff_name}</td>
              <td className="p-3 border-b border-gray-100 text-center">{row.vendor_name}</td>
              <td className="p-3 border-b border-gray-100 text-center">
                            <button
                              onClick={() => {
                                const receiptId = row.receipt_note_id;
                                localStorage.setItem("receiptId", receiptId);
                                window.open("/create-receipt-form", "_blank");
                              }}
                            >
                              <EyeIcon size={18} />
                            </button>
                          </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
